"use client";
import MuiTextField, {
  type TextFieldProps as MuiTextFieldProps,
} from "@mui/material/TextField";
import { type ReactNode } from "react";
import InfoAdornment from "@/components/common/formElements/library/InfoAdornment";

export interface TextInputProps extends Omit<MuiTextFieldProps, "title"> {
  tooltip?: ReactNode;
}

export default function TextInput(props: TextInputProps) {
  const {
    children,
    error,
    minRows = 2,
    fullWidth = true,
    variant = "outlined",
    tooltip,
    slotProps,
    ...textFieldProps
  } = props;

  const inputSlotProps = tooltip
    ? {
        ...slotProps?.input,
        endAdornment: <InfoAdornment tooltip={tooltip} />,
      }
    : slotProps?.input;

  return (
    <MuiTextField
      error={error}
      variant={variant}
      minRows={minRows}
      fullWidth={fullWidth}
      slotProps={{
        ...slotProps,
        input: inputSlotProps,
      }}
      {...textFieldProps}
    >
      {children}
    </MuiTextField>
  );
}
